import { Environment } from 'types';
export namespace HostModuleTest {
  export class Configurator implements Persistance {
    env: Environment;
    options: Environment[];
    isOpen: boolean = false;
    showMaintenance: boolean = false;
    ignoreVersionsMismatch: boolean = false;

    constructor(persistance?: Persistance) {
      this.env =
        (persistance && persistance.env) ||
        (process.env.NODE_ENV as Environment) ||
        Environment.Development;
      this.options = [
        Environment.Development,
        Environment.Stage,
        Environment.Production,
      ];
      this.showMaintenance = persistance ? persistance.showMaintenance : false;
      this.ignoreVersionsMismatch = persistance
        ? persistance.ignoreVersionsMismatch
        : false;
    }
  }
  export interface Persistance {
    env: Environment;
    options: Environment[];
    showMaintenance: boolean;
    ignoreVersionsMismatch: boolean;
  }
}
